import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse } from '@angular/common/http';
import { User } from '../_models';
import { HttpHeaders } from '@angular/common/http';
import { getCountries,Plan,responsedata,ListPlan,editplanresponsedata } from '../interface'
import { Observable } from 'rxjs';
import { map,catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable()
export class CommonService {
	constructor(private http: HttpClient) {}
	getCountries() {
		return this.http.get < any > (environment.url + `getLiveCountries`);
	}

	getOrganisation() {
		return this.http.post < any > (environment.url + `getOrganisations`, '');
	}

	getPlanlist(page: number, pageSize: number, planfilter): Observable < ListPlan > {
		const formData = new FormData();
		formData.append('page', page.toString());
		let currentUser = JSON.parse(localStorage.getItem('currentUser'));
		let usermasterid = currentUser.user_master_id;
		let utoken = currentUser.utoken;
		const httpOptions = {
			headers: new HttpHeaders({
				"Access-Control-Allow-Methods": "GET, POST",
				"Access-Control-Allow-Origin": "*",
				'utoken': atob(utoken),
				'usermasterid': atob(usermasterid),
				'planname': planfilter.planname,
				'plantype': planfilter.plantype,
				'status': planfilter.status,
				'planstartdate': planfilter.planstartdate,
				'planenddate': planfilter.planenddate,
			})
		}
		return this.http.post < ListPlan > (environment.url + `listPlans`, formData, httpOptions).pipe(catchError(this.handleError));
	}
    
    createplan(plan: Plan): Observable < responsedata > {
		var pid = ""
		if ((plan.Organisation.length != undefined) && (plan.Organisation.length != 0)) {
			pid = plan.Organisation[0]["org_id"]
		}
		if (plan.planid == 0) {
			const formData = new FormData();
			formData.append('plan_image', plan.plan_image_path);
			const httpOptions = {
				headers: new HttpHeaders({
					"Access-Control-Allow-Methods": "GET, POST",
					"Access-Control-Allow-Origin": "*",
					'utoken': atob(plan.utoken),
					'usermasterid': atob(plan.usermasterid),
					'planname': plan.planname,
					'plandescription': plan.plandescription,
					'planstartdate': plan.planstartdate,
					'planenddate': plan.planenddate,
					'plantokencount': plan.plantokencount,
					'planamount': plan.planamount,
					'plancurrency': plan.plancurrency,
					'plancountryid': plan.plancountryid,
					'plantype': plan.plantype,
					'status': plan.planstatus,
					'planimagename': plan.plan_image,
					'orgid': pid
				})
			};
			return this.http.post < responsedata > (environment.url + `addEditPlans`, formData, httpOptions).pipe(catchError(this.handleError));
		}
	}

	updateplan(plan) {
		var pid = ""
		if (plan.Organisation.length != 0) {
			pid = plan.Organisation[0].org_id
		}
		let planimage = "";
		const formData = new FormData();
		formData.append('plan_image', plan.plan_image_path);
		const httpOptions = {
			headers: new HttpHeaders({
				"Access-Control-Allow-Methods": "GET, POST",
				"Access-Control-Allow-Origin": "*",
				'utoken': atob(plan.utoken),
				'usermasterid': atob(plan.usermasterid),
				'planname': plan.planname,
				'plandescription': plan.plandescription,
				'planstartdate': plan.planstartdate,
				'planenddate': plan.planenddate,
				'plantokencount': plan.plantokencount,
				'planamount': plan.planamount,
				'plancurrency': plan.plancurrency,
				'plancountryid': plan.plancountryid,
				'plantype': plan.plantype,
				'status': plan.planstatus,
				'planid': plan.plan_id,
				'planimagename': plan.plan_image,
				'orgid': pid
			})
		};
		return this.http.post < any > (environment.url + `addEditPlans`, formData, httpOptions).pipe(catchError(this.handleError));
	}

	deleteplanlogo(plan_id) {
		let currentUser = JSON.parse(localStorage.getItem('currentUser'));
		let usermasterid = currentUser.user_master_id;
		let utoken = currentUser.utoken;
		const httpOptions = {
			headers: new HttpHeaders({
				'utoken': atob(utoken),
				'loginuserid': atob(usermasterid),
				'planid': "" + plan_id + ""
			})
		}
		return this.http.post < any > (environment.url + `deleteplanelogo`, '', httpOptions).pipe(catchError(this.handleError));
	}

	geteditplandata(planid) {
		let currentUser = JSON.parse(localStorage.getItem('currentUser'));
		let usermasterid = currentUser.user_master_id;
		let utoken = currentUser.utoken;
		const httpOptions = {
			headers: new HttpHeaders({
				"Access-Control-Allow-Methods": "GET, POST",
				"Access-Control-Allow-Origin": "*",
				'utoken': atob(utoken),
				'usermasterid': atob(usermasterid),
				'getsingle': 'Yes',
				'loginuserid': atob(usermasterid),
				'planid': planid
			})
		}
		return this.http.post < editplanresponsedata > (environment.url + `getPlans`, '', httpOptions).pipe(catchError(this.handleError));
	}

	updatestatus(planid: string, status) {
		let currentUser = JSON.parse(localStorage.getItem('currentUser'));
		let usermasterid = currentUser.user_master_id;
		let utoken = currentUser.utoken;
		const httpOptions = {
			headers: new HttpHeaders({
				"Access-Control-Allow-Methods": "GET, POST",
				"Access-Control-Allow-Origin": "*",
				'utoken': atob(utoken),
				'usermasterid': atob(usermasterid),
				'tblname': 'tbl_plan_master',
				'comparecolumnname': 'plan_id',
				'comparecolumndata': planid,
				'statuscolumnname': 'status',
				'statusdata': status,
			})
		}
		return this.http.post < responsedata > (environment.url + `changeStatus`, '', httpOptions).pipe(catchError(this.handleError));
	}

	private handleError(error: HttpErrorResponse) {
		if (error.error instanceof Error) {
			const errMessage = error.error.message;
			return Observable.throw(errMessage);
		}
		return Observable.throw(error || 'Node.js server error');
	}

	listQueueTemplates(page: any, size: any, queueTemplateFilter: any) {
		const formData = new FormData();
		let currentUser = JSON.parse(localStorage.getItem('currentUser'));
		let usermasterid = currentUser.user_master_id;
		let utoken = currentUser.utoken;
		const httpOptions = {
			headers: new HttpHeaders({
				"Access-Control-Allow-Methods": "GET, POST",
				"Access-Control-Allow-Origin": "*",
				'utoken': atob(utoken),
				'loginuserid': atob(usermasterid),
				"page": "" + page + "",
				"orgtype": queueTemplateFilter.searchorgtype,
				"queuename": queueTemplateFilter.searchQueueTemplate,
				"status": queueTemplateFilter.searchQueueTemplateStatus
			})
		}
		return this.http.post < responsedata > (environment.url + `listQueueTemplates`, formData, httpOptions).pipe(catchError(this.handleError));
	}

	getQueueTemplates(queueTemplateId: any) {
		const formData = new FormData();
		let currentUser = JSON.parse(localStorage.getItem('currentUser'));
		let usermasterid = currentUser.user_master_id;
		let utoken = currentUser.utoken;
		const httpOptions = {
			headers: new HttpHeaders({
				"Access-Control-Allow-Methods": "GET, POST",
				"Access-Control-Allow-Origin": "*",
				'utoken': atob(utoken),
				'loginuserid': atob(usermasterid),
				"queuetemplateid": queueTemplateId,
			})
		}
		return this.http.post < responsedata > (environment.url + `getQueueTemplates`, formData, httpOptions).pipe(catchError(this.handleError));
	}

	addEditQueueTemplate(QueueTempalteForm: any, queueTemplateId: any = "", imageValues: any = "") {
		const formData = new FormData();
		formData.append("queue_image", imageValues.onchangeFilName);
		formData.append("queue_image_name", imageValues.queueExistingImage);
		let currentUser = JSON.parse(localStorage.getItem('currentUser'));
		let usermasterid = currentUser.user_master_id;
		let utoken = currentUser.utoken;
		const httpOptions = {
			headers: new HttpHeaders({
				"Access-Control-Allow-Methods": "GET, POST",
				"Access-Control-Allow-Origin": "*",
				'utoken': atob(utoken),
				'loginuserid': atob(usermasterid),
				'queuetemplateid': queueTemplateId,
				'orgtype': QueueTempalteForm.value.servicetype,
				"queuename": QueueTempalteForm.value.queueTemplateName,
				"status": QueueTempalteForm.value.queueTemplateStatus,
			})
		}
		return this.http.post < responsedata > (environment.url + `addEditQueueTemplate`, formData, httpOptions).pipe(catchError(this.handleError));
	}

	getLanguageList(page: any, size: any, languageFilter: any) {
		const formData = new FormData();
		formData.append('languagecode', languageFilter.language_code);
		formData.append('languagename', languageFilter.language_name);
		formData.append('status', languageFilter.status);
		let currentUser = JSON.parse(localStorage.getItem('currentUser'));
		let usermasterid = currentUser.user_master_id;
		let utoken = currentUser.utoken;
		const httpOptions = {
			headers: new HttpHeaders({
				"Access-Control-Allow-Methods": "GET, POST",
				"Access-Control-Allow-Origin": "*",
				'utoken': atob(utoken),
				'usertype': "admin",
				'loginuserid': atob(usermasterid),
				"page": page,
			})
		}
		return this.http.post < responsedata > (environment.url + `getLanguageListAndDetails`, formData, httpOptions).pipe(catchError(this.handleError));
	}

	getLanguageDetails(languageId: any) {
		const formData = new FormData();
		let currentUser = JSON.parse(localStorage.getItem('currentUser'));
		let usermasterid = currentUser.user_master_id;
		let utoken = currentUser.utoken;
		const httpOptions = {
			headers: new HttpHeaders({
				"Access-Control-Allow-Methods": "GET, POST",
				"Access-Control-Allow-Origin": "*",
				'utoken': atob(utoken),
				'usertype': "admin",
				'loginuserid': atob(usermasterid),
				'languageid': languageId
			})
		}
		return this.http.post < responsedata > (environment.url + `getLanguageListAndDetails`, formData, httpOptions).pipe(catchError(this.handleError));
	}

	addEditLanguage(languageForm: any, languageId: any = "", ) {
		const formData = new FormData();


		formData.append('languagename', languageForm.value.languageName);
		formData.append('languageid', languageId);
		formData.append('status', languageForm.value.languageStatus);
		formData.append('languagecode', languageForm.value.languagecode);

		let currentUser = JSON.parse(localStorage.getItem('currentUser'));
		let usermasterid = currentUser.user_master_id;
		let utoken = currentUser.utoken;
		var headersdata = new Headers();
		const httpOptions = {
			headers: new HttpHeaders({
				'utoken': atob(utoken),
				'loginuserid': atob(usermasterid),
			})
		}
		return this.http.post < responsedata > (environment.url + `addEditLanguage`, formData, httpOptions).pipe(catchError(this.handleError));
	}
}


// WEBPACK FOOTER //
// ./src/app/_services/common.service.ts